import { useEffect, useState } from "react";

import { SigninResponse, State } from "../../interfaces";
import { getLoggedInUserSession } from "../../helpers/api_helper";
import { useSelector } from "react-redux";

const useSession = () => {
  const userSession = getLoggedInUserSession();
  let token: string = userSession && userSession["token"];
  const [loading, setLoading] = useState(userSession ? false : true);
  const [session, setSession] = useState<SigninResponse>(
    userSession ? userSession : null
  );

  const {
    loading: loggingIn,
    error: loginError,
    success: loginSuccess,
  } = useSelector((state: any): State<any> => state.auth.login);

  useEffect(() => {
    const userSession = getLoggedInUserSession();
    var token = userSession && userSession["token"];
    setSession(userSession ? userSession : null);
    setLoading(token ? false : true);
  }, [loggingIn]);

  return { session, loading, token };
};

export { useSession };
